<template>
  <b-link
    class="d-block"
    v-bind="is_external? { href: link, target: '_blank'}: { to: link}"
  >
    <slot />
  </b-link>
</template>
<script>
export default {
  name: "CustomLink",
  props: ["url"],
  data() {
    let link = this.url;
    let is_external = false;
    if (link) {
      is_external = link.startsWith("http");
      if (!is_external && !link.startsWith("/")) {
        link = "/" + link;
      }
    }
    return {
      is_external: is_external,
      link: link
    };
  }
};
</script>